import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Themed } from "@components/atoms/Themed"
import { ResponsiveImageFragment } from "../../types.graphql"
import { twMerge } from "tailwind-merge"
import { Chip } from "@components/atoms/Chip"
import { Gradient } from "@components/motion/Gradient"
import { EditableText } from "eddev/blocks"
import { useSearchParams } from "eddev/routing"

const MODES = {
  "a-z": "A-Z",
  date: "by Date",
  calendar: "Calendar",
  shorts: "Shorts",
}

export const HeaderBrowse = ({
  theme,
  featuredImage,
  hideShorts = false,
}: {
  theme: string
  featuredImage?: ResponsiveImageFragment
  hideShorts?: boolean
}) => {
  const [params, paramsApi] = useSearchParams({
    mode: null as string | null,
  })

  const mode = (params.mode as keyof typeof MODES) || "a-z"

  return (
    <Themed
      theme={theme}
      type="bg"
      className="w-full flex flex-col md:flex-row md:pl-7 gap-7 pl-4 pr-4 py-4 justify-between relative"
    >
      {featuredImage?.srcSet?.split(" ")?.[0] && (
        <Gradient
          theme={theme}
          className="absolute left-0 top-0 h-full bg-white"
          aspect="1/1"
          showImage={false}
          cutEdges={false}
          align="left"
          scale={1}
          // speed={0.5}
          bg={{ r: 1, g: 1, b: 1 }}
        />
      )}
      <div className="flex flex-col justify-between items-start w-full self-stretch relative">
        <div className="flex flex-col gap-6 mt-5">
          <div className="flex gap-3 items-center">
            <Chip>
              <EditableText
                as="span"
                store="on-now"
                placeholder="Miami Film Festival"
                defaultValue="Miami Film Festival"
                plainText
              />
            </Chip>
            <Chip variant="ghost">
              <EditableText
                as="span"
                store="on-now-sub"
                placeholder="ON SALE NOW"
                defaultValue="ON SALE NOW"
                plainText
              />
            </Chip>
          </div>
          <p className="type-title-xxl">Browse {MODES[mode]}</p>
        </div>
        <div className="flex gap-4 justify-start items-center mb-4">
          {Object.keys(MODES).map(
            (key) =>
              (key !== "shorts" || (key === "shorts" && !hideShorts)) && (
                <div
                  key={key}
                  className={twMerge(
                    "type-label-l uppercase cursor-pointer relative hover-link",
                    key === mode && "hover-link-active",
                  )}
                  onClick={() => paramsApi.set("mode", key as keyof typeof MODES)}
                >
                  {MODES[key as keyof typeof MODES]}
                </div>
              ),
          )}
        </div>
      </div>
      <div className="w-full md:w-pageHeaderBrowseFeatW shrink-0 flex justify-center items-center relative">
        <ResponsiveImage {...featuredImage} className="w-full h-auto" />
      </div>
    </Themed>
  )
}
